import { Button, FormControlLabel, IconButton } from '@material-ui/core';
import React, { useState } from 'react';
import Modal from './Modal';
import moment from 'moment';
import { FileUploader } from '../UI';
import { CustomTextField } from '../Textfield';
import { CustomDatePicker } from '../DateTimePicker';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import { connect } from 'react-redux';
import {
    addStaffPayment,
    editStaffPayment,
} from '../../store/actions/paymentActionCreator';
import { Switch } from '@material-ui/core';
import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object({
    advance: yup.bool('Advance is invalid'),
    dateEpochMillis: yup.string('Date is invalid').required('Date is required'),
    amount: yup.number('Amount is invalid').required('Amount is required'),
    paymentData: yup.string('Reference No is invalid'),
    notes: yup.string('Notes is invalid'),
    docLink: yup.string('file is invalid'),
});

function AddPaymentModal({
    open,
    onClose,
    staffInfo,
    data = {},
    isEdit = false,
    dispatchAddStaffPayment,
    dispatchEditStaffPayment,
    ...props
}) {
    const [isOpen, toggleModal] = useState(open);
    const [loading, toggleLoading] = useState(false);
    const [datePickerOpen, setDatePickerOpen] = useState(false);

    const formik = useFormik({
        initialValues: {
            dateEpochMillis: moment().valueOf(),
            advance: false,
            amount: '',
            paymentData: '',
            notes: '',
            docLink: '',
            ...data,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await toggleLoading(true);
            if (Object.keys(data)?.length > 1) {
                dispatchEditStaffPayment(
                    data.id,
                    { ...values, id: staffInfo.id },
                    async (resp) => {
                        await toggleLoading(false);
                        handleClose();
                    },
                    async (resp) => {
                        await toggleLoading(false);
                    },
                );
            } else {
                dispatchAddStaffPayment(
                    { id: staffInfo.id, ...values },
                    async (resp) => {
                        await toggleLoading(false);
                        handleClose();
                    },
                    async (resp) => {
                        await toggleLoading(false);
                    },
                );
            }
        },
    });

    const handleClose = () => {
        toggleModal(!isOpen);
        onClose && onClose();
    };

    const actions = [
        <Button
            key={2}
            variant="contained"
            color="primary"
            className={`saveButton`}
            type="submit"
            disableElevation
        >
            {isEdit ? 'Update' : 'Add'}
        </Button>,
    ];

    console.log(data);

    return (
        <Modal
            onClose={handleClose}
            open={isOpen}
            title={isEdit ? 'Edit Payments' : 'Add Payments'}
            subtitle={`${isEdit ? 'Edit' : 'Add'} Payments of your staff`}
            actions={actions}
            loading={loading}
            isForm={true}
            stickyActions={true}
            onSubmit={formik.handleSubmit}
        >
            <FormControlLabel
                control={
                    <Switch
                        checked={formik.values.advance}
                        id="advance"
                        name="advance"
                        value={formik.values.advance}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.advance
                                ? Boolean(formik.errors.advance)
                                : false
                        }
                        helperText={
                            formik.touched.advance && formik.errors.advance
                        }
                        color="primary"
                    />
                }
                label="Advance"
                labelPlacement="start"
                style={{ marginBottom: 10, marginLeft: 1 }}
            />
            <CustomTextField
                label="Date"
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <IconButton
                            className={'inputbutton'}
                            onClick={(e) => setDatePickerOpen(true)}
                        >
                            <InsertInvitationIcon size="small" />
                        </IconButton>
                    ),
                }}
                onClick={(e) => setDatePickerOpen(true)}
                id="dateEpochMillis"
                name="dateEpochMillis"
                value={moment(formik.values.dateEpochMillis).format(
                    'yyyy-MM-DD',
                )}
                onChange={formik.handleChange}
                error={
                    formik.touched.dateEpochMillis
                        ? Boolean(formik.errors.dateEpochMillis)
                        : false
                }
                helperText={
                    formik.touched.dateEpochMillis &&
                    formik.errors.dateEpochMillis
                }
                variant="outlined"
                style={{ marginBottom: '16px' }}
                isRequired={true}
            />
            <CustomTextField
                fullWidth={true}
                label="Amount"
                variant="outlined"
                inputProps={{
                    type: 'number',
                    min: 1,
                }}
                id="amount"
                name="amount"
                value={formik.values.amount}
                onChange={formik.handleChange}
                error={
                    formik.touched.amount
                        ? Boolean(formik.errors.amount)
                        : false
                }
                helperText={formik.touched.amount && formik.errors.amount}
                style={{ marginBottom: '16px' }}
                isRequired={true}
            />
            <CustomTextField
                fullWidth={true}
                label="Reference Number"
                variant="outlined"
                id="paymentData"
                name="paymentData"
                value={formik.values.paymentData}
                onChange={formik.handleChange}
                error={
                    formik.touched.paymentData
                        ? Boolean(formik.errors.paymentData)
                        : false
                }
                helperText={
                    formik.touched.paymentData && formik.errors.paymentData
                }
                style={{ marginBottom: '16px' }}
            />
            <CustomTextField
                multiline={true}
                rows={4}
                fullWidth={true}
                label="Notes"
                variant="outlined"
                id="notes"
                name="notes"
                value={formik.values.notes}
                onChange={formik.handleChange}
                error={
                    formik.touched.notes ? Boolean(formik.errors.notes) : false
                }
                helperText={formik.touched.notes && formik.errors.notes}
            />
            <FileUploader
                label={'Upload Support Document'}
                placeholder={'Upload Support Document'}
                onFileUploaded={(url) => {
                    console.log(url);
                    formik.setFieldValue('docLink', url, true);
                }}
                defaultValue={formik.values.docLink}
                error={
                    formik.touched.docLink
                        ? Boolean(formik.errors.docLink)
                        : false
                }
                helperText={formik.touched.docLink && formik.errors.docLink}
            />

            {datePickerOpen && (
                <CustomDatePicker
                    open={datePickerOpen}
                    onOpen={() => setDatePickerOpen(true)}
                    onClose={() => setDatePickerOpen(false)}
                    format="d MMM yyyy"
                    value={formik.values.dateEpochMillis}
                    onChange={(e) => {
                        console.log(moment(e).valueOf());
                        formik.setFieldValue(
                            'dateEpochMillis',
                            moment(e).valueOf(),
                            true,
                        );
                        // setSelectedDate(moment(e));
                    }}
                    allowFutureDates={false}
                />
            )}
        </Modal>
    );
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    dispatchAddStaffPayment: (payload, onSuccess, onError) =>
        dispatch(addStaffPayment(payload, onSuccess, onError)),
    dispatchEditStaffPayment: (id, payload, onSuccess, onError) => {
        console.log('dispatchEditStaffPayment', { ...payload, paymentId: id });
        return dispatch(
            editStaffPayment({ ...payload, paymentId: id }, onSuccess, onError),
        );
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPaymentModal);
